if(typeof BSS_B2B != 'undefined' && window.location.pathname === '/pages/wholesale-signup2'){
  setTimeout(() => {
    const elm = document.querySelectorAll(".field input, #bss-b2b-registration-form-render .form-group input,  #bss-b2b-registration-form-render .form-group textarea");
    if(elm.length > 0){
      elm.forEach(item => {
        item.addEventListener("keyup", () => {
          item.style = "outline-color: var(--color-scheme-accent);outline-offset: 0.25rem;outline-style: solid;outline-width: var(--text-width);"
        })
        item.addEventListener("blur", () => {
          item.style = "outline: none"
        })
      })
    }
  }, 200)
}

if(typeof BSS_B2B != 'undefined'){
  setTimeout(() => {
    const elm = document.querySelector("#addToCartButton");
    if(elm){
    elm.addEventListener("click", function(e) {
    let quantityInputElement = document.querySelector([
        '.product-form__quantity .quantity__input',
        `input[id^='product-quantity-product']`,
        'form[action="/cart/add"] input#quantity[name="quantity"]',
        `input[name='quantity']`
    ].join(','));
    let currentQtyValue = parseInt(quantityInputElement.value)
    setTimeout(() => {
        quantityInputElement.value = currentQtyValue;
    }, 500)
}, true)
      
    }
  }, 300)
}
